// Cadre "navigateur" élégant pour présenter des captures d'écran produit.
export const BrowserMockup = ({ src, alt, url = "gestimmony.fr", className = "", imgClassName = "", priority = false }) => (
  <figure className={`overflow-hidden rounded-xl border border-stone-200 bg-white shadow-2xl shadow-stone-900/10 ${className}`}>
    <div className="flex items-center gap-2 border-b border-stone-200 bg-stone-50 px-4 py-2.5">
      <span className="flex gap-1.5">
        <span className="h-3 w-3 rounded-full bg-[#ff5f57]" />
        <span className="h-3 w-3 rounded-full bg-[#febc2e]" />
        <span className="h-3 w-3 rounded-full bg-[#28c840]" />
      </span>
      <div className="mx-auto flex items-center gap-1.5 rounded-md bg-white border border-stone-200 px-3 py-1 text-[11px] text-slate-400 max-w-[70%] truncate">
        <svg className="h-3 w-3 text-slate-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
        {url}
      </div>
    </div>
    <img src={src} alt={alt} loading={priority ? "eager" : "lazy"} className={`block w-full ${imgClassName}`} draggable={false} />
  </figure>
);

export default BrowserMockup;
